import React, { useState } from 'react';
import { SpendingSumModel } from 'src/types/spending-sum.model';
import { trackClick } from 'src/hooks/useAdobeTags';
import adobeTags from 'src/types/adobe-tags';
import FormatService from 'src/services/format.service';
import styles from './categoryCardCollapsible.module.scss';
import { getBudgetForCategory } from 'src/utils/budget.utils';
import CategoryCard from 'src/components/atomic/organisms/categoryCard/CategoryCard';
import { BudgetModel } from 'src/types/budget.model';
import { CategoryModel } from 'src/types/category.model';
import * as H from 'history';
import Selectors from 'src/utils/selectors';

interface CategoryCardCollapsibleProps {
    parentCategory: SpendingSumModel;
    subcategories?: SpendingSumModel[];
    categories: CategoryModel[];
    history: H.History;
    parentBudget?: BudgetModel;
    subcategoryBudgets?: BudgetModel[];
    isMinWidthSmall?: boolean;
    addBorder?: boolean;
}

export default function CategoryCardCollapsible({
    parentCategory,
    subcategories,
    categories,
    history,
    parentBudget,
    subcategoryBudgets,
    isMinWidthSmall,
    addBorder
}: CategoryCardCollapsibleProps): JSX.Element {
    const [showingSubcategories, setShowingSubcategories] = useState<boolean>(false);

    const handleShowSubcategories = (): void => {
        setShowingSubcategories(!showingSubcategories);
        trackClick(
            history.location.pathname,
            `${
                showingSubcategories ? adobeTags.CategoryBreakdown.Expand : adobeTags.CategoryBreakdown.Close
            }>${FormatService.formatTag(parentCategory.groupName)}`
        );
    };

    return (
        <div
            className={
                addBorder && !showingSubcategories
                    ? styles.categoryCardCollapsibleWithBorder
                    : styles.categoryCardCollapsible
            }
        >
            <CategoryCard
                spending={parentCategory}
                budget={parentBudget}
                history={history}
                categories={categories}
                hasSubcategories={subcategories?.length > 0}
                isMinWidthSmall={isMinWidthSmall}
                showingSubcategories={showingSubcategories}
                handleShowSubcategories={handleShowSubcategories}
            />
            {subcategories && showingSubcategories && (
                <ul
                    className={styles.subcategories}
                    id={`category-card-subcategories-${parentCategory.groupId}`}
                    aria-labelledby={`category-card-show-subcategories-button-${parentCategory.groupId}`}
                    data-cy={Selectors.SpendSmart.CATEGORY_CARD_COLLAPSIBLE_MENU}
                >
                    {subcategories.map((subCategory) => (
                        <li className={styles.subcategoryCard} key={subCategory.groupId}>
                            <CategoryCard
                                spending={subCategory}
                                parentName={parentCategory.groupName}
                                key={subCategory.groupId}
                                categories={categories}
                                budget={getBudgetForCategory(subcategoryBudgets, subCategory.groupId)}
                                history={history}
                                isMinWidthSmall={isMinWidthSmall}
                            />
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
}
